module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/truck-3230480d17b314a9735ecf97cbdc6062.png";